module.exports = __webpack_public_path__ + "static/media/logo-agroreceita-branco.73cab05d.svg";